let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("epgGV")).then(() => parcelRequire('5k2HF'));